import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
  static targets = ["notesList", "noteContent"];

  createSuccess(event) {
    const [_data, _status, xhr] = event.detail;
    const response = JSON.parse(xhr.response);

    // Update the notes list with the new HTML
    this.notesListTarget.innerHTML = response.notes_list_html;

    // Clear the textarea
    this.noteContentTarget.value = "";

    // Extract party inquiry ID from the form action URL
    const form = event.target;
    const actionUrl = form.action;
    const partyInquiryId = actionUrl.match(/party_inquiries\/(\d+)/)[1];

    // Update the badge count
    this.updateBadge(partyInquiryId, response.notes_count);

    // Optionally show a brief success indicator
    this.showSuccessMessage();
  }

  createError(event) {
    const [_data, _status, xhr] = event.detail;
    console.error("Error creating note:", xhr.response);

    alert(this.errorMessage(xhr, "Failed to create note. Please try again."));
  }

  deleteError(event) {
    const [_data, _status, xhr] = event.detail;
    console.error("Error deleting note:", xhr.response);

    alert(this.errorMessage(xhr, "Failed to delete note. Please try again."));
  }

  // A 409 is a Parties tab left open from before Events v2 was switched on: trying again won't help.
  errorMessage(xhr, fallback) {
    return xhr.status === 409 ? "That Parties page is out of date, so nothing changed. Reload the page." : fallback;
  }

  deleteSuccess(event) {
    const [_data, _status, xhr] = event.detail;
    const response = JSON.parse(xhr.response);
    const link = event.target.closest("a");
    const noteId = link.dataset.noteId;
    const noteElement = document.getElementById(`note-${noteId}`);

    if (noteElement) {
      // Remove the note element
      noteElement.remove();

      // Extract party inquiry ID from the link href URL
      const hrefUrl = link.href;
      const partyInquiryId = hrefUrl.match(/party_inquiries\/(\d+)/)[1];

      // Update the badge count
      this.updateBadge(partyInquiryId, response.notes_count);

      // Check if there are no more notes
      const notesList = this.notesListTarget.querySelector(".list-group");
      if (!notesList || notesList.children.length === 0) {
        // Show empty state
        this.notesListTarget.innerHTML = `
          <div class="text-center text-muted py-4">
            <i class="bi bi-sticky bi-2x mb-2"></i>
            <p class="mb-0">No notes yet. Add one below!</p>
          </div>
        `;
      }
    }
  }

  showSuccessMessage() {
    // Optional: Add a temporary success message
    const successEl = document.createElement("div");
    successEl.className = "alert alert-success alert-dismissible fade show mt-2 mb-3";
    successEl.innerHTML = `
      Note added successfully!
      <button type="button" class="btn-close" data-bs-dismiss="alert"></button>
    `;

    this.notesListTarget.insertAdjacentElement("afterend", successEl);

    // Auto-dismiss after 3 seconds
    setTimeout(() => {
      successEl.remove();
    }, 3000);
  }

  updateBadge(partyInquiryId, count) {
    const badge = document.getElementById(`note-badge-${partyInquiryId}`);
    const notesLink = document.querySelector(`[data-party-inquiry-id="${partyInquiryId}"]`);

    if (count > 0) {
      if (badge) {
        // Badge exists, just update the count
        badge.textContent = count;
      } else if (notesLink) {
        // Badge doesn't exist, create it
        const badgeHTML = `
          <span class="position-relative">
            <span id="note-badge-${partyInquiryId}" class="badge bg-white position-absolute text-primary border border-primary" style="font-size: 0.5rem; top: -0.5rem; left: 8px;">
              ${count}
            </span>
          </span>
        `;
        notesLink.insertAdjacentHTML('beforeend', badgeHTML);
      }
    } else {
      // Count is 0, remove the badge if it exists
      if (badge) {
        badge.closest('.position-relative').remove();
      }
    }
  }
}
